// @core/api/endpoints/team/add_schedule_participant.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddScheduleParticipantRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Add participant to schedule
 * Performs add operation on schedule participant.
 */
export async function AddScheduleParticipant(
  team_id: string,
  schedule_id: string,
  data: AddScheduleParticipantRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/schedules/:schedule_id/participants`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':schedule_id', encodeURIComponent(schedule_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
